import Image from "next/image";
import { fetchGetCompanySiteSettings } from "../../../services/api";
import { useEffect, useState } from "react";

export default function Header({ company }) {

    const [activePages, setActivePages] = useState([])
    useEffect(() => {
        const pages = []
        fetchGetCompanySiteSettings()
            .then(res => {
                pages.push({ route: '', name: "Home" })
                res.showNew === true ? pages.push({ route: "novos", name: "0 Km" }) : null;
                res.showUsed === true ? pages.push({ route: "seminovos", name: "Seminovos" }) : null;
                res.showArmored === true ? pages.push({ route: "blindados", name: "Blindados" }) : null;
                pages.push({ route: 'sobre-nos', name: "Sobre" })
                res.showFinancing === true ? pages.push({ route: "financiamento", name: "Financiamento" }) : null;
                res.showVehiclePurchase === true ? pages.push({ route: "venda-seu-veiculo", name: "Venda seu Veículo" }) : null;
                res.showInsurance === true ? pages.push({ route: "seguro", name: "Seguro" }) : null;
                pages.push({ route: 'contato', name: "Contato" })
                setActivePages(pages)
            })
    }, [])

    const formatPhone = (phone) => {
        if (!phone) return null;

        if (phone.length === 10) {
            return `(${phone.substring(0, 2)}) ${phone.substring(2, 6)}-${phone.substring(6, 10)}`;
        }

        if (phone.length === 11) {
            return `(${phone.substring(0, 2)}) ${phone.substring(2, 7)}-${phone.substring(7, 11)}`;
        }

        return phone;
    };

    return (
        <>
            <header className="header-style-one header-sticky">
                <div className="at_topbar d-none d-sm-block bg-white">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-4 col-lg-5 col-8">
                                <div className="tp-info">
                                    <p className="mb-0">{`${company.nickName} a melhor revenda de veículos`}</p>
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-7 col-4">
                                <div className="tp-info-wrapper d-flex align-items-center justify-content-end">
                                    <div className="tp-info d-inline-flex align-items-center">
                                        <span className="icon-wrapper me-2">
                                            <i className="flaticon-phone-call flaticonPlace"></i>
                                        </span>
                                        <a href={`tel:+55${company.phone}`}>
                                            <p className="mb-0">{formatPhone(company.phone)}</p>
                                        </a>
                                        {company.phone2 && (
                                            <>
                                                <span className="icon-wrapper me-2 ms-4 d-none d-xl-inline-flex">
                                                    <i className="flaticon-phone-call flaticonPlace"></i>
                                                </span>
                                                <a href={`tel:+55${company.phone2}`}>
                                                    <p className="mb-0">{formatPhone(company.phone2)}</p>
                                                </a>
                                            </>
                                        )}
                                    </div>
                                    <div className="d-none tp-info d-xl-inline-flex align-items-center">
                                        <span className="icon-wrapper me-2">
                                            <i className="flaticon-email flaticonPlace"></i>
                                        </span>
                                        <a href={`mailto:${company.email}`}><p className="mb-0">{company.email}</p></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="at_header_nav">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-6 col-lg-3">
                                <div className="companyLogo">
                                    <a href="/">
                                        {company.logo ?
                                            <Image
                                                src={company.logo}
                                                alt="logo"
                                                width={185}
                                                height={72}
                                                sizes="100vw"
                                                quality={100}
                                                loading="lazy"
                                                style={{
                                                    marginTop: '4px',
                                                    marginBottom: '4px'
                                                }} />
                                            : <div></div>
                                        }
                                    </a>
                                </div>
                            </div>
                            <div className="col-6 col-lg-9">
                                <div className="at_header_right d-flex align-items-center justify-content-end">
                                    <nav className="at_nav_menu d-none d-lg-block">
                                        <ul>
                                            {activePages.map((page, index) => (
                                                <li key={index}><a href={`/${page.route}`}>{page.name}</a></li>
                                            ))}
                                        </ul>
                                    </nav>
                                    <button className="mobile-menu-toggle header-toggle-btn ms-4 d-lg-none" aria-label="Abrir Menu">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className="mobile-menu position-fixed bg-white deep-shadow">
                <button className="close-menu position-absolute" aria-label="Fechar Menu"><i className="fa-solid fa-xmark"></i></button>
                <a href="/" className="logo-wrapper bg-black d-block mt-4 p-3 rounded-1 text-center">
                    {company.logo ?
                        <Image
                            src={company.logo}
                            alt="logo"
                            width={185}
                            height={72}
                            sizes="100vw"
                            quality={100} />
                        : <div></div>
                    }
                </a>
                <nav className="mobile-menu-wrapper mt-20">
                    <ul>
                        {activePages.map((page, index) => (
                            <li key={index}><a href={`/${page.route}`}>{page.name}</a></li>
                        ))}
                    </ul>
                </nav>
                <div className="contact-info mt-60">
                    <h4 className="mb-20">Contato</h4>
                    <a href={`tel:+55${company.phone}`}>
                        <p>
                            {company.phone ?
                                company.phone.length === 10
                                    ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 6)}-${company.phone.substring(6, 10)}`
                                    : company.phone.length === 11
                                        ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 7)}-${company.phone.substring(7, 11)}`
                                        : company.phone
                                : null}
                        </p>
                    </a>
                    <a href={`mailto:${company.email}`}><p>{company.email}</p></a>
                    <div className="social-contact">
                        {company.facebook ? <a href={company.facebook} target='_blank' rel="noreferrer" aria-label="Acesse o facebook da nossa loja"><i className="fab fa-facebook-f"></i></a> : null}
                        {company.instagram ? <a href={company.instagram} target='_blank' rel="noreferrer" aria-label="Acesse o instagram da nossa loja"><i className="fab fa-instagram"></i></a> : null}
                        {company.youtube ? <a href={company.youtube} target='_blank' rel="noreferrer" aria-label="Acesse o youtube da nossa loja"><i className="fab fa-youtube"></i></a> : null}
                        {company.tiktok ? <a href={company.tiktok} target='_blank' rel="noreferrer" aria-label="Acesse o youtube da nossa loja"><i className="fab fa-tiktok"></i></a> : null}
                    </div>
                </div>
            </div>
        </>
    );
}